import React from 'react';
import { FaLinkedin, FaInstagram, FaTwitter, FaFacebook } from 'react-icons/fa';

const SocialLinks = ({ socialLinks }) => {
  return (
    <div className="mt-3">
      <p>
        <span>Social Links: </span>
        {socialLinks?.linkedin && (
        <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="mx-2 text-primary" aria-label="LinkedIn">
          <FaLinkedin size={24} />
        </a>
      )}
      {socialLinks?.instagram && (
        <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="mx-2 text-primary" aria-label="Instagram">
          <FaInstagram size={24} />
        </a>
      )}
      {socialLinks?.twitter && (
        <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer" className="mx-2 text-primary" aria-label="Twitter">
          <FaTwitter size={24} />
        </a>
      )}
      {socialLinks?.facebook && (
        <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="mx-2 text-primary" aria-label="Facebook">
          <FaFacebook size={24} />
        </a>
      )}
      </p>
    </div>
  );
};

export default SocialLinks;
